import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Typography, { TypographyProps } from "@mui/material/Typography";
import { useState } from "react";

import { getBoxStyles } from "../numericInputs/styles/styles";

export type RTextInputLabelProps = {
  value: string | null | undefined;
  onInputChange: (value: string) => void;
  maxLength?: number;
  typographyProps?: TypographyProps;
  placeholder?: string;
  multiline?: boolean;
};

export default function RTextInputLabel({
  value,
  onInputChange,
  maxLength,
  typographyProps,
  placeholder,
  multiline = false,
}: RTextInputLabelProps) {
  const [isEditing, setIsEditing] = useState(false);
  const [inputValue, setInputValue] = useState(value ?? "");

  const handleDoubleClick = () => {
    setIsEditing(true);
    setInputValue(value ?? "");
  };

  const handleBlur = () => {
    setIsEditing(false);
    if (inputValue !== value) {
      onInputChange(inputValue);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" && !multiline) {
      setIsEditing(false);
      if (inputValue !== value) {
        onInputChange(inputValue);
      }
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!maxLength || e.target.value.length <= maxLength) {
      setInputValue(e.target.value);
    }
  };

  return (
    <Box
      onDoubleClick={handleDoubleClick}
      onBlur={isEditing ? handleBlur : undefined}
      onKeyDown={isEditing ? handleKeyDown : undefined}
      sx={getBoxStyles(isEditing)}>
      {isEditing ? (
        <TextField
          value={inputValue}
          onChange={handleChange}
          // eslint-disable-next-line jsx-a11y/no-autofocus -- autoFocus is only triggered after a user double-clicks to edit, so it does not harm accessibility or usability.
          autoFocus
          fullWidth
          multiline={multiline}
          placeholder={placeholder}
          inputProps={{ maxLength }}
          variant="standard"
        />
      ) : (
        <Typography {...typographyProps} sx={{ textAlign: "left" }}>
          {value ?? ""}
        </Typography>
      )}
    </Box>
  );
}
